import Experience from './components/Experience/';
import Spinner from '../../../../../../components/Spinner/';

import React from 'react';
import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';

const ExperienceData = gql`
query {
  viewer {
    job_positions {
      UserPositionID: id
      StartDate: start_date
      EndDate: end_date
      JobTitle: name
      SortOrder: sort_order
      company {
        id
        name
      }
    }
    industries {
      industry_id
    }
  }
  
  getIndustryCategories {
    id
    name
    industries {
      id
      name
    }
  }
}
`;

const UpsertPosition = gql`
mutation userjobpositions(
  $Experience: [UserPositionInput]
) {
  setUserExperience(
    positions: $Experience
  ) {
    id
  }
}`;

const UpsertIndustry = gql`
mutation(
  $IndustryInputs: [IndustryInput]!
) {
  setUserIndustry (
    Industries: $IndustryInputs
  ) {
    id
  }
}
`;

const DeletePosition = gql`
mutation(
  $PositionID: Int!
) {
  deleteUserJobPosition (
    JobUserPostionID: $PositionID
  ) {
    id
  }
}
`;

export default (store) => ({
  path: 'experience',
  component: compose(
    graphql(UpsertPosition, {
      name: 'SetPositions',
    }),
    graphql(UpsertIndustry, {
      name: 'UpsertIndustry',
    }),
    graphql(ExperienceData, {
      name: 'ExperienceData',
      options: {
        fetchPolicy: 'network-only'
      },
    }),
    graphql(DeletePosition, {
      name: 'DeletePosition',
    }),
  )((props) => {
    if (props.ExperienceData.loading === false) {
      return <Experience {...props} />;
    }
    return <Spinner />;
  }),
});



// WEBPACK FOOTER //
// ./src/routes/advisor/routes/Profile/routes/Experience/index.js